export default {
  examResults: [],
  examResult: {},
}
